/**
 * Child Records & Documentation Page
 * Standalone page for managing children's records and documentation
 */
import { useAuth } from "@/contexts/AuthContext";
import { useState } from "react";
import AppShell from "@/components/layout/AppShell";
import { ChildrenRecordsTab } from "@/components/children-records";
import PageHero, { HERO_IMAGES } from "@/components/common/PageHero";

const ChildRecordsPage = () => {
  const { user, organization } = useAuth();
  const [childRefreshSignal, setChildRefreshSignal] = useState(0);

  return (
    <AppShell pageTitle="Child Records & Documentation" breadcrumb>
      {/* Hero Banner */}
      <PageHero 
        imageUrl={HERO_IMAGES.childRecords}
        title="Compliance Records"
        subtitle="Manage children's documents, medical forms, and records"
        altText="Organizing children's records"
      />
      
      <div className="relative z-10">
        <ChildrenRecordsTab 
          organizationName={organization?.name || user?.organization?.name || ''} 
          refreshSignal={childRefreshSignal}
        />
      </div>
    </AppShell>
  );
};

export default ChildRecordsPage;
